import React from "react";
import config from "./../config.json";
import authService from "../services/authService";
import {
  HubConnectionBuilder,
  HubConnectionState,
  LogLevel,
} from "@microsoft/signalr";

const token = authService.getToken();
const chatUrl = process.env.REACT_APP_CHAT_HUB_URL || config.chatHubUrl;

const getInitialConnection = () => {
  const connection = new HubConnectionBuilder()
    .withUrl(chatUrl, { accessTokenFactory: () => token })
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Error)
    .build();

  return connection;
};

export const ChatContext = React.createContext();

export const ChatProvider = ({ children }) => {
  const [connection, setConnection] = React.useState(getInitialConnection);

  React.useEffect(() => {
    setConnection(connection);

    if (connection.state === HubConnectionState.Disconnected)
      connection.start();
  }, [connection]);

  return (
    <ChatContext.Provider value={[connection, setConnection]}>
      {children}
    </ChatContext.Provider>
  );
};
